import React from 'react';
import PropTypes from 'prop-types';

import styles from './componentStyles/buttonLink.module.css';

const ButtonLink = (props) => (
  <span>
    <div className={props.tooltip ? styles.tooltip : ''}>
      <form
        target={props.newTab ? '_blank' : null}
        rel={props.newTab ? 'noopener noreferrer' : null}
        action={props.link}
        className={props.vertical ? styles.vertical : styles.horizontal}
      >
        <button
          type='submit'
          className={[
            props.disabled ? styles.disabled : '',
            props.secondary ? styles.secondary : '',
          ].join(' ')}
        >
          <span className={styles.buttonText}>{props.text}</span>
        </button>
      </form>
      <span
        className={[
          styles.tooltipText,
          props.tooltipPosition === 'top' ? styles.top : styles.bottom,
        ].join(' ')}
      >
        {props.tooltipText}
      </span>
      <span
        className={[
          styles.tooltipConnector,
          props.tooltipPosition === 'top' ? styles.top : styles.bottom,
        ].join(' ')}
      />
    </div>
  </span>
);

ButtonLink.propTypes = {
  text: PropTypes.string,
  link: PropTypes.string,
  vertical: PropTypes.bool,
  newTab: PropTypes.bool,
  tooltip: PropTypes.bool,
  tooltipText: PropTypes.node,
  tooltipPosition: PropTypes.string,
  secondary: PropTypes.bool,
};

ButtonLink.defaultProps = {
  vertical: true,
  newTab: true,
  tooltip: false,
  secondary: false,
};

export default ButtonLink;
